import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M10.75 9.5A2.75 2.75 0 108 6.75M9.5 9.5h1.333m-6 0H6.5M5 9.5a2.5 2.5 0 010-5m5.475 7.313L8 14.288l-2.475-2.475M8 13.833V6.666M4.5 5a3.5 3.5 0 016.063-2.384"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M16.125 14.25A4.125 4.125 0 1012 10.125m2.25 4.125h2m-9 0h2.5m-2.25 0a3.75 3.75 0 010-7.5m8.212 10.97L12 21.432 8.288 17.72M12 20.75V10M6.75 7.5a5.25 5.25 0 019.094-3.576"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M32.25 28.5A8.25 8.25 0 1024 20.25m4.5 8.25h4m-18 0h5m-4.5 0a7.5 7.5 0 010-15m16.424 21.94L24 42.864l-7.424-7.424M24 41.5V20"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M13.5 15c0-5.798 4.702-10.5 10.5-10.5 3.036 0 5.77 1.288 7.688 3.348"
  }))
};
export var Download = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});